import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

type Size = 'x-small' | 'small' | 'medium' | 'large';
type Color = 'destructive' | 'warning' | 'success' | 'primary';

export interface LabelElement extends HTMLElement {
  size?: Size;
  color?: Color;
}

const OpLabel = createWrapper<LabelElement>('op-label');

export default OpLabel;
